import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import RouterUtils from '../../../shared/routing/RouterUtils';
import { PsRoutes } from '../../../shared/routing/Routes';
import { ActiveBadge } from '../../../shared/components/ActiveLabel';
import { PsListTable } from '../../../shared/components/list-table/PsListTable';
import DocumentState from '../../../shared/components/DocumentState';
import { PsMoreMenu } from '../../../shared/components/more-menu/PsMoreMenu';
import { PsDocumentSchemasTd } from '../../../shared/components/document-schemas-td/PsDocumentSchemasTd';
import { PsDocumentWorkerPositionTd } from '../../../shared/components/document-schemas-td/PsDocumentWorkerPositionTd';

export class WorkerListTable extends React.Component {

    render() {
        const {
            data,
            error,
            loading,
        } = this.props;

        return (
            <PsListTable
                data={data}
                error={error}
                loading={loading}
                headings={(
                    <tr>
                        <th>{I18nUtils.tr('TR_ESTADO')}</th>
                        <th>{I18nUtils.tr('TR_DOCUMENTACION')}</th>
                        <th>{I18nUtils.tr('TR_DNI_NIF')}</th>
                        <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                        <th>{I18nUtils.tr('TR_OFICIO')}</th>
                        <th>{I18nUtils.tr('TR_ESQUEMA')}</th>
                        <th/>
                    </tr>
                )}
            >
                {
                    data.map((worker) => {
                        const workerId = worker.id();
                        const route = RouterUtils.generateRoute(PsRoutes.MY_CONTRACTORS_WORKERS_DETAIL, { workerId });
                        const options = [
                            {
                                label: I18nUtils.tr('TR_EDITAR'),
                                route,
                            },
                        ];

                        return (
                            <tr key={workerId}>
                                <td><ActiveBadge active={worker.isActive()}/></td>
                                <td><DocumentState state={worker.documentationStateData()}/></td>
                                <td>{worker.dni()}</td>
                                <td>{worker.completeName()}</td>
                                <td><PsDocumentWorkerPositionTd schemas={worker.documentationWorkerPosition()}/></td>
                                <td><PsDocumentSchemasTd schemas={worker.documentationDescription()}/></td>
                                <td><PsMoreMenu options={options}/></td>
                            </tr>
                        );
                    })
                }
            </PsListTable>
        );
    }

}

WorkerListTable.propTypes = {
    data: PropTypes.array,
    error: PropTypes.string,
    loading: PropTypes.bool,
};

WorkerListTable.defaultProps = {
    data: [],
    error: '',
};



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/list/WorkerListTable.jsx